import { Component, h } from 'preact'
import axios from 'axios'
import { t } from '../../libs/translationsUtils/translations'
import tracker from '../../components/tracker/publish'
import { getCurrentPage } from '../common/index'
import Analytics from '../analytics/Analytics'

const eventTracker = () => {
  tracker.trackEvent('userevent', {
    type: 'Sidebar Widget Clicked',
    widget: 'solved topics',
    click_source: getCurrentPage()
  })

  if (getCurrentPage() === 'homepage') {
    Analytics.send('Homepage', 'Widget clicked', {
      Type: 'Solved topics'
    })
  }
}

type Topic = {
  title: string,
  url: string,
  numberOfReplies: number,
  lastPost: {
    url: string
  }
}

interface Props {
  title: string,
  query: {
    maxResults: string,
    minReplies: number,
    prefixIds: Array<string>,
    sort: string,
    sortOrder: string,
  }
}

interface State {
  topics: Array<Topic>
}

class SolvedTopics extends Component<Props, State> {
  constructor () {
    super()
    this.state = {
      topics: []
    }
  }

  async componentDidMount () {
    const { data } = await axios.get('/widget/solvedTopics', {
      params: {
        query: JSON.stringify(this.props.query)
      }
    })

    this.setState({ topics: data })
  }

  render ({ title }: Props, { topics }: State) {
    if (!topics.length) {
      return null
    }
    return (
      <div className='box__content box__pad widget-solvedtopics'>
        { title ? <h3 className='widget-title'>{title}</h3> : '' }
        <ul className='list simple-topic-list' onClick={eventTracker}>
          {
            topics.map((topic) => {
              return (
                <li class='simple-topic-list--item'>
                  <h6 class='simple-topic-list--title'>
                    <a className='link link--topic' href={topic.url}>{topic.title}</a>
                    <span className='icon icon--round icon--checkmark text--success qa-icon-answered' />
                  </h6>
                  <a href={topic.lastPost.url} className='text--meta'>{topic.numberOfReplies} {t('Forum', 'Reply', { value: topic.numberOfReplies.toString() })}</a>
                </li>
              )
            })
          }
        </ul>
      </div>
    )
  }
}

export default SolvedTopics
